import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../app/queryKeys';
import {
    createClassroom,
    updateClassroomById,
    deleteClassroomById,
    CreateClassroomPayload,
    UpdateClassroomPayload,
} from '../../services/ClassroomService';

export function useClassroomMutations() {
    const queryClient = useQueryClient();

    const addClassroomMutation = useMutation({
        mutationFn: (payload: CreateClassroomPayload) => createClassroom(payload),
    });

    const editClassroomMutation = useMutation({
        mutationFn: ({ id, payload }: { id: string; payload: UpdateClassroomPayload }) =>
            updateClassroomById(id, payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.classrooms.all });
        },
    });

    const deleteClassroomMutation = useMutation({
        mutationFn: (classroomId: string) => deleteClassroomById(classroomId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.classrooms.all });
        },
    });

    return {
        addClassroomMutation,
        editClassroomMutation,
        deleteClassroomMutation,
    };
}
